import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('edit-accordion', {
  template: require('./template.html'),
  mixins: [guid],
  computed: {
    ...mapGetters(['viewport']),
    minCount() {
      const total = this.droplet.sections.length;
      let disableClass = false;
      if (total <= 1) {
        disableClass = true;
      }
      return disableClass;
    },
  },
  name: 'edit-accordion',
  data() {
    return {
      display: {
        search: false,
        arrow: false,
      },
    };
  },
  props: ['droplet', 'show-edit-bubble'],
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.search = this.droplet.search;
      this.display.arrow = this.droplet.arrow;
    },
    addSection() {
      const newSec = {
        _id: this.guid(),
        title: 'Title',
        droplets: [],
        type: 'droplet.accordion.section',
      };
      const payload = {};
      payload.drp = this.droplet;
      payload.newSec = newSec;
      this.promise(this.$store.dispatch('addNewAccSection', payload));
    },
    removeSection(i) {
      const total = this.droplet.sections.length;
      if (total > 1) {
        const payload = {};
        payload.drp = this.droplet;
        payload.secIndex = i;
        this.promise(this.$store.dispatch('removeAccSection', payload));
      }
    },
    bouncePlugin() {
      this.$vnode.context.unBindPlugin();
      this.$vnode.context.bindPlugin();
    },
    drzRevertData() {
      this.$emit('css-generator');
      this.bouncePlugin();
    },
    getTitle(html) {
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      return wrap.textContent;
    },
    promise(action) {
      const promise = new Promise((resolve) => {
        if (action) {
          resolve();
        }
      });
      promise.then(() => {
        this.bouncePlugin();
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/accordion/components/_edit-options/index.js